import { ComplaintsDocumentType } from "../complaints-document-types";
import { SalesDocumentType } from "../sales-document-types";
import { ComplaintFiltersDTO } from "./complaint-filters.model";
import { SalesDocumentFiltersDTO } from "./sales-document-filters.model";
import { SalesDocument } from "./sales-document.model";

export const documentListColumns = [
    'documentNumber',
    'externalSource',
    'client',
    'seller',
    'created',
    'modified',
    'requestedDeadline',
    'status',
    'priceBeforeDiscounts',
    'priceAfterDiscounts',
    'priority',
    'primaryKey',
    'assignedToCompany'
] as const;
export type ColumnKey = typeof documentListColumns[number];

export type ColumnSortOrder = {
    column: ColumnKey;
    order: 'asc' | 'desc' | null;
}[];

export type DocumentWithChildren = {
    doc: SalesDocument;
    children: SalesDocument[];
    onlyPurchase?: boolean;
    orderPlaced?: boolean;
    message?: string;
    messageState?: 'default' | 'error';
    connectedDocumentIds: string[];
    connectedDocumentsStatuses?: number[];
};

export interface DocumentRequestParams {
    userId: number;
    appVersion: string;
    salesDocumentTypeId: SalesDocumentType;
    side: 'sales' | 'purchase';
    unplaced: boolean;
    filters: SalesDocumentFiltersDTO | ComplaintFiltersDTO;
    sort: ColumnSortOrder;
    offset: number;
    limit: number;
    type: 'sales' | 'complaint';
    complaintType?: ComplaintsDocumentType;
};
